import * as React from 'react';
import * as styles from './styles.css';

import { Spinner } from '@cian/ui-kit';

export const Loader: React.FC = () => {
  return (
    <div data-testid="Loader" className={styles['container']}>
      <Spinner size={32} />
    </div>
  );
};
